import type { ErrorLike } from '@apollo/client';
import { useEffect } from 'react';

import { useLoader } from '@hooks/useLoader';
import { RequestState } from '@src/types/index';

type UsePageStateHandlerProps = {
  loading: boolean;
  hasData: boolean;
  error?: boolean | ErrorLike;
};

const usePageStateHandler = ({
  loading,
  hasData,
  error,
}: UsePageStateHandlerProps) => {
  const { setRequestState } = useLoader();

  const isLoading = loading || (!hasData && !error);
  const hasError = error || !hasData;

  useEffect(() => {
    if (isLoading) {
      setRequestState(RequestState.loading);
    } else if (hasError) {
      setRequestState(RequestState.error);
    } else {
      setRequestState(RequestState.success);
    }
  }, [isLoading, hasError, setRequestState]);

  return { isLoading, hasError };
};

export { usePageStateHandler };
